// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Per assets/handoffs (WordPress connection alert spec). Not a card: no
   header band, no rules, no shadow-xs — a tinted status field, full page
   width, with its own margin-bottom (not the shared .cardCol/.setupRow
   spacing DashboardPage.js uses for actual cards). */

.wpc-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: var(--color-brand-25);
  border: 1px solid var(--color-brand-200);
  border-radius: var(--radius-xl);
  margin-bottom: 24px;
}

.wpc-icon {
  flex: none;
  margin-top: 2px;
  color: var(--fg-brand-primary);
}

/* Title and body both inherit this — the tinted text is what reads as one
   unit against the brand-25 field. Deliberately not --text-primary. */
.wpc-content {
  min-width: 0;
  color: var(--color-brand-800);
}

.wpc-title {
  display: block;
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  font-weight: 600;
}

.wpc-body {
  margin: 4px 0 0;
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  font-weight: 400;
  max-width: 78ch;
  text-wrap: pretty;
}

.wpc-body b {
  font-weight: 600;
}

/* Flex row so a second action could sit alongside this one later without
   re-layout — today it holds one child. */
.wpc-action {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.wpc-action a {
  font-family: var(--font-family-body);
  font-size: var(--text-sm-size);
  line-height: 1;
  font-weight: 600;
  color: inherit;
  text-decoration: none;
}

.wpc-action a:hover,
.wpc-action a:focus {
  text-decoration: underline;
}

.wpc-action a:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-brand-100);
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/DashboardPage/CompleteWPConnection.css"],"names":[],"mappings":"AAAA;;;qDAGqD;;AAErD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,wCAAwC;EACxC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,8BAA8B;AAChC;;AAEA;sEACsE;AACtE;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;0CAC0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB","sourcesContent":["/* Per assets/handoffs (WordPress connection alert spec). Not a card: no\n   header band, no rules, no shadow-xs — a tinted status field, full page\n   width, with its own margin-bottom (not the shared .cardCol/.setupRow\n   spacing DashboardPage.js uses for actual cards). */\n\n.wpc-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background: var(--color-brand-25);\n  border: 1px solid var(--color-brand-200);\n  border-radius: var(--radius-xl);\n  margin-bottom: 24px;\n}\n\n.wpc-icon {\n  flex: none;\n  margin-top: 2px;\n  color: var(--fg-brand-primary);\n}\n\n/* Title and body both inherit this — the tinted text is what reads as one\n   unit against the brand-25 field. Deliberately not --text-primary. */\n.wpc-content {\n  min-width: 0;\n  color: var(--color-brand-800);\n}\n\n.wpc-title {\n  display: block;\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  font-weight: 600;\n}\n\n.wpc-body {\n  margin: 4px 0 0;\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  font-weight: 400;\n  max-width: 78ch;\n  text-wrap: pretty;\n}\n\n.wpc-body b {\n  font-weight: 600;\n}\n\n/* Flex row so a second action could sit alongside this one later without\n   re-layout — today it holds one child. */\n.wpc-action {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.wpc-action a {\n  font-family: var(--font-family-body);\n  font-size: var(--text-sm-size);\n  line-height: 1;\n  font-weight: 600;\n  color: inherit;\n  text-decoration: none;\n}\n\n.wpc-action a:hover,\n.wpc-action a:focus {\n  text-decoration: underline;\n}\n\n.wpc-action a:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-brand-100);\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
